import { createSlice } from '@reduxjs/toolkit';
import { createAsyncReducers } from '~utils/createAsyncReducers';
import { name } from './constants';
import { getSports } from './thunks';
var initialState = {
    data: [],
    loading: 'idle',
    error: null,
};
export var sport = createSlice({
    name: name,
    initialState: initialState,
    reducers: {},
    extraReducers: function (builder) {
        var _a = createAsyncReducers(), pending = _a.pending, fulfilled = _a.fulfilled, rejected = _a.rejected;
        builder
            .addCase(getSports.pending, pending)
            .addCase(getSports.fulfilled, fulfilled)
            .addCase(getSports.rejected, rejected);
    },
});
export default sport.reducer;
